import { DEFAULT_ANIMATE_DURATION, noForwardProps } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import ParagraphBlockLinkButton from '@src/components/battle/demo/blocks/ParagraphBlockLinkButton'
import ParagraphBlockView from '@src/components/battle/demo/blocks/ParagraphBlockView'
import { HeaderParagraphsBlock, ParagraphBlock } from '@src/types/pageBuilder'
import * as R from 'ramda'

type Props = {
  href?: string
  layoutProps?: HeaderParagraphsBlock['layoutProps']
  paragraphBlocks: ParagraphBlock[]
  title: string
}

const Container = styled(Box, noForwardProps)<{ __marginTop?: number }>`
  display: flex;
  flex-direction: column;
  column-gap: 30px;

  ${({ __marginTop }) =>
    R.isNotNil(__marginTop) && `margin-top: ${__marginTop}px;`}

  ${props => props.theme.breakpoints.up('res1024')} {
    margin-left: auto;
    margin-right: auto;
  }

  row-gap: 12px;
`

const TitleContainer = styled(Box)`
  display: flex;
`

const Title = styled(Box)`
  background: #5c528d;
  color: white;
  padding: 2px 14px;
  border-radius: 4px;
  font-size: 20px;

  transition: transform ${DEFAULT_ANIMATE_DURATION}ms,
    filter ${DEFAULT_ANIMATE_DURATION}ms;

  :hover {
    filter: brightness(1.1);
    transform: translateY(-3px);
  }
`

const Paragraphs = styled(Box, noForwardProps)<{ __spaceY: number }>`
  > * + * {
    margin-top: ${({ __spaceY }) => __spaceY}px;
  }
`

const HeaderParagraphsBlockView = ({
  href,
  layoutProps,
  paragraphBlocks,
  title
}: Props) => {
  return (
    <Container __marginTop={layoutProps?.marginTop}>
      <TitleContainer>
        <Title>{title}</Title>
        <ParagraphBlockLinkButton href={href} />
      </TitleContainer>
      <Paragraphs __spaceY={layoutProps?.paragraphSpaceY ?? 12}>
        {paragraphBlocks.map((paragraphBlock, index) => {
          const key = `${title}-${index}`

          return (
            <ParagraphBlockView
              key={key}
              text={paragraphBlock.value}
              layoutProps={paragraphBlock.layoutProps}
              variant={paragraphBlock.variant}
            />
          )
        })}
      </Paragraphs>
    </Container>
  )
}

export default HeaderParagraphsBlockView
